//changed due to package upgrade
import React, { useEffect, useState } from 'react';
import { Box, Button, alpha, Typography, Grid } from '@mui/material';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import AppGridContainer from '@projectK/components/AppGridContainer';
import { useParams } from 'react-router-dom';
import jwtAxios from '@projectK/services/auth/JWT';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import { useInfoViewActionsContext } from '@projectK/context';
import PopupRequest from '../PopupRequest';
import AppLoader from '@projectK/components/AppLoader';
const getTag = (item) => {
  if (!item?.add_status) {
    return item?.type === 'free' ? 'Free' : 'Premium';
  }
  return item.add_status;
};

const getTagColor = (item) => {
  switch (item?.add_status) {
    case 'active':
      return 'available_btn';
    case 'expiring today':
      return 'expiring_today_btn';
    case 'expiring tomorrow':
      return 'expiring_tomorrow_btn';
    case 'expired':
      return 'expired_btn';
    case 'in-active':
      return 'inactive_btn';
    case 'not started at':
      return 'not_started_btn';
    default:
      return item?.type === 'free' ? 'available_btn' : 'premium_btn';
  }
};
const ViewMarketPlace = () => {
  const companyTheme = CompanyTheme();
  const { slug } = useParams();
  const [addonData, setAddonData] = useState({});
  const { user } = useAuthUser();
  const infoViewActionsContext = useInfoViewActionsContext();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await jwtAxios.get(`/add-on/${slug}`);
      const { data } = response;
      setAddonData(data);
      setLoading(false);
    } catch (error) {
      console.error('error fetch addon data', error);
      setLoading(false);
    }
  };
  function renderHtml(html) {
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  }
  useEffect(() => {
    if (slug) {
      fetchData();
    }
  }, [slug]);

  useEffect(() => {
    if(addonData?.id){
     handleViews(addonData.id);
    }
  }, [addonData?.id]);
  let banner_url = '';
  if (addonData?.banner_url) {
    banner_url = `${process.env.NX_CLOUD_FRONT_URL}/${addonData?.banner_url}`;
  }
  let logo_url = '';
  if (addonData?.logo_url) {
    logo_url = `${process.env.NX_CLOUD_FRONT_URL}/${addonData?.logo_url}`;
  }
  const handleDemoRequests = async (id) => {
    try {
      await jwtAxios.post('/addon-demoRequest', {
        user_id: user.id,
        user_email: user.email,
        user_role: user.role[0],
        addon_id: id,
      });
      setIsDialogOpen(true);
    } catch (error) {
      infoViewActionsContext.fetchError(
        error?.response?.data?.error || error?.response,
      );
    }
  };

    const handleViews = async (id) => {
    try {
      await jwtAxios.post('/addon-analytics', {
        addon_id: id,
      });
    } catch (error) {
      console.error(
        error?.response?.data?.error || error?.response,
      );
    }
  };
const isDisableButton =   addonData?.add_status !== null && addonData?.add_status === 'active';
  return (
    <AppGridContainer>
        {loading && <AppLoader />}
        <Grid size={{ xs: 12,  md: 3 }}>        <Box
          className='enroll_leftpanel'
          sx={{
            height: '100%',
            width: '100%',
            backgroundImage: `url(${banner_url})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <Box className='img_box'>
            {logo_url ? <img src={logo_url} alt='logo' width='100%' /> : null}
          </Box>
        </Box>
      </Grid>
      {addonData && ( <Grid size={{ xs: 12, md: 9 }}>

        <Box className='enroll_rightpanel'>
          <Box className='enrollment'>
            <Typography variant='h2'>
              {addonData?.name}{' '}
              <Button
                variant='contained'
                size='small'
                className={`status_btn ${getTagColor(addonData)}`}
              >
                {getTag(addonData)}
              </Button>
            </Typography>

            <Typography variant='body1'>{addonData?.tagline}</Typography>
            <div className='price-analytic'>
              {addonData?.media_url ? (
                <img
                  src={`${process.env.NX_CLOUD_FRONT_URL}/${addonData?.media_url}`}
                  alt='media'
                  style={{
                    width: '100%',
                    aspectRatio: '2', // width is 2x the height
                    objectFit: 'cover', // optional, helps maintain crop behavior
                  }}
                />
              ) : null}
              <div
                className='img_box MuiBox-root css-0'
                style={{ fontWeight: 800 }}
              >
                ${addonData?.price}
              </div>
            </div>

            <Typography variant='h3'>Description</Typography>
            <Box sx={{ my: 4, fontSize: '1.2rem' }}>
              {renderHtml(addonData?.full_description)}
            </Box>
          </Box>
          {/* Buttons Section */}
          <Box
            className='bottom_btns'
            sx={{ display: 'flex', gap: 3, justifyContent: 'space-between' }}
          >
            <Button
              variant='contained'
              size='large'
              fullWidth
              disabled={isDisableButton}
              onClick={() => handleDemoRequests(addonData.id)}
              sx={{
                backgroundColor: companyTheme
                  ? companyTheme.primary.main
                  : '#2196f3',
                '&:hover': {
                  backgroundColor: companyTheme
                    ? alpha(companyTheme.primary.main, 0.8)
                    : alpha('#2196f3', 0.8),
                },
              }}
            >
              Request Activation
            </Button>
          </Box>
        </Box>
      </Grid>)}

      {isDialogOpen && (
        <PopupRequest
          isDialogOpen={isDialogOpen}
          setIsDialogOpen={setIsDialogOpen}
          companyTheme={companyTheme}
          addonName={addonData?.name}
        />
      )}
    </AppGridContainer>
  );
};

export default ViewMarketPlace;
